import React from 'react'
import { Check, Send } from 'lucide-react'
import { Chip } from 'components/ui'
import { useCreationText } from '../../hooks/useCreationText'
import styles from './styles.module.css'

/** Decorative task preview; readiness and the real submit action belong to SettingsBuilder. */
export function SettingsReadyIllustration() {
  const t = useCreationText()

  return (
    <div className={styles.illustration} aria-hidden="true">
      <div className={styles.sheet} />
      <div className={styles.card}>
        <div className={styles.summary}>
          <div className={styles.badges}>
            <Chip label={<>{t.newTask}</>} size="sm" color="#346cf2" bg="#e8efff" border="none" />
            <Chip
              label={
                <span className={styles.readyBadge}>
                  <Check size={12} /> {t.ready}
                </span>
              }
              size="sm"
              color="#5c7c25"
              bg="#edf4e4"
              border="none"
            />
          </div>
          <div className={styles.taskTitle} />
          <div className={styles.types}>
            <span />
            <span />
            <span />
          </div>
        </div>
        <div className={styles.rows}>
          {[0, 1, 2].map((row) => (
            <div className={styles.row} key={row}>
              <span className={styles.settingIcon} />
              <div className={styles.lines}>
                <span />
                <span />
              </div>
              <span className={styles.check}>
                <Check size={13} strokeWidth={2.5} />
              </span>
            </div>
          ))}
        </div>
      </div>
      <span className={styles.send}>
        <Send size={22} />
      </span>
    </div>
  )
}
